import { render } from "./MessageEngagement.vue?vue&type=template&id=3212d405&scoped=true"
import script from "./MessageEngagement.vue?vue&type=script&lang=js"
export * from "./MessageEngagement.vue?vue&type=script&lang=js"

import "./MessageEngagement.vue?vue&type=style&index=0&id=3212d405&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3212d405"]])

export default __exports__